import React, { Component } from 'react';
import { translate } from "react-i18next";
import { getURL } from '../../backend/Backend';
import { Row, Col, Pagination } from 'react-bootstrap';
import { getDateDisplayValue } from '../../backend/UIUtils';
import AdminStatisticSearch from './AdminStatisticSearch';

class AdminStatisticsList extends Component {

    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.pageChanged = this.pageChanged.bind(this);
        this.searchEvents = this.searchEvents.bind(this);

        this.state = {
            events: [],
            activePage: 1,
            totalPages: 0,
            criteria: null
        }
    }

 

    async searchEvents(criteria, page) {

        if (!page || !criteria) {
            return;
        }
        if ("<" === page) {
            page = --this.state.activePage;
        }
        if (">" === page) {
            page = ++this.state.activePage;
        }

        let converted = 'startDate=' + (criteria.startDate ? criteria.startDate : ''); 
        converted += "&";
        converted += 'endDate=' + (criteria.endDate ? criteria.endDate : '');
        converted += "&";
        converted += 'unitID=' + (criteria.unitID ? criteria.unitID : '0');
        converted += "&";
        converted += 'page=' + (page-1);
      

        const response = await fetch(getURL(`statistics?${converted}`));
        const json = await response.json();
        let oldState = this.state;
        this.setState({
            ...oldState,
            events: json.content,
            totalPages: json.totalPages,
            activePage: page,
            criteria: criteria
        });
    }


    async pageChanged(e) {
        this.searchEvents(this.state.criteria, e.target.text);
    }


    handleChange(oldParameter) {

        let parameters = this.state.parameters;
        let p = parameters.find(p => p.key === oldParameter.key);
        let pIndex = parameters.findIndex(p => p.key === oldParameter.key);


        p.value = oldParameter.value === '1' ? '0' : '1';



        let newParameters = [...parameters.slice(0, pIndex),
            p,
        ...parameters.slice(pIndex + 1)];

        this.setState({
            parameters: newParameters
        });
    }

    render() {
        let sep = '-';
        const { t } = this.props;
        var options = { weekday: 'short', day: 'numeric', month: 'short', year: '2-digit'};
       return <div>
                    <AdminStatisticSearch searchEvents={this.searchEvents}/>
                    {this.state.events.map((e, i) =>
                       <Row key={e.id}>
                           <Col lg="2">{e.unitID}</Col>
                           <Col lg="2">{getDateDisplayValue(e.creationDate, options)}</Col>
                           <Col lg="1">{e.result}</Col>
                       </Row>
                    )}
                    <Pagination onClick={this.pageChanged}>
                    {this.state.activePage > 1 ?
                        <Pagination.Item>{'<'}</Pagination.Item>
                        : ""
                    }

                    {[...Array(this.state.totalPages).keys()].map(i => {
                        return <Pagination.Item active={(i + 1) === this.state.activePage} key={i}>{i + 1}</Pagination.Item>
                    })
                    }
                    {this.state.activePage < this.state.totalPages ?
                        <Pagination.Item>{'>'}</Pagination.Item>
                        : ""
                    }

                </Pagination>
            </div>
    }
}

export default translate("translations")(AdminStatisticsList);